<div class="tab-data-container">
	@if (requestData.attached_files && requestData.attached_files.length === 0) {
		<div class="attach">Esse chamado ainda não tem arquivo anexados</div>
	}

	@for (attach of requestData.attached_files; track $index) {
		<div class="attach link" (click)="downloadFile(attach.attachedFile)">
			<fa-icon class="mr-1" [icon]="icons.faDownload"></fa-icon>{{ formatAttachPath(attach.attachedFile) }}
		</div>
	}
</div>
